/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Authorization_Sign_In_TitleInputs */

const en_agent_authorization_sign_in_title = /** @type {(inputs: Agent_Authorization_Sign_In_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in to make this decision`)
};

const zh_agent_authorization_sign_in_title = /** @type {(inputs: Agent_Authorization_Sign_In_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登录后处理此请求`)
};

/**
* | output |
* | --- |
* | "Sign in to make this decision" |
*
* @param {Agent_Authorization_Sign_In_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const agent_authorization_sign_in_title = /** @type {((inputs?: Agent_Authorization_Sign_In_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Authorization_Sign_In_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_agent_authorization_sign_in_title(inputs)
	return zh_agent_authorization_sign_in_title(inputs)
});
export { agent_authorization_sign_in_title as "agent.authorization.sign_in_title" }